import {
  getGruposCobranca,
  getPortfolios,
  getJustificativas,
  getAjuizamentoJustificativas,
  getStatus,
  getOrigem,
  getPerfis,
  getTipoAcao,
  getEmpresas,
  getTipoMovimento,
  getTipoContrato,
  getAllShoppings,
  getTipoConta,
  getTipoEmpresa,
  getModules,
  getStatusSerasa,
} from './endpoints';

export type Key =
  | 'getAllShoppings'
  | 'getGruposCobranca'
  | 'getPortfolios'
  | 'getJustificativas'
  | 'getAjuizamentoJustificativas'
  | 'getStatus'
  | 'getOrigem'
  | 'getPerfis'
  | 'getTipoAcao'
  | 'getEmpresas'
  | 'getTipoEmpresa'
  | 'getTipoMovimento'
  | 'getTipoContrato'
  | 'getTipoConta'
  | 'getModules'
  | 'getStatusSerasa';

type Fn = () => Promise<any>;

const Requests = (() => {
  let instance: Map<Key, Fn>;

  function createInstance() {
    return new Map<Key, () => Promise<any>>([
      ['getAllShoppings', getAllShoppings],
      ['getGruposCobranca', getGruposCobranca],
      ['getPortfolios', getPortfolios],
      ['getJustificativas', getJustificativas],
      ['getAjuizamentoJustificativas', getAjuizamentoJustificativas],
      ['getStatus', getStatus],
      ['getOrigem', getOrigem],
      ['getPerfis', getPerfis],
      ['getTipoAcao', getTipoAcao],
      ['getEmpresas', getEmpresas],
      ['getTipoEmpresa', getTipoEmpresa],
      ['getTipoMovimento', getTipoMovimento],
      ['getTipoContrato', getTipoContrato],
      ['getTipoConta', getTipoConta],
      ['getModules', getModules],
      ['getStatusSerasa', getStatusSerasa],
    ]);
  }

  return {
    getInstance: () => {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    },
  };
})();

export const requests = Requests.getInstance();
